import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserSkipService {
  private baseUrl = `${environment.urlConfig.serviceUrl}/customerskips`;

  constructor(private http: HttpClient) { }
  
  skipTask(request: Boo.UserSkips.Objects.TaskUserSkipRequest): Observable<any> {
    return this.http.post(`${this.baseUrl}/SkipTask`, request);
  }

  skipCustomerTaskType(request: Boo.UserSkips.Objects.CustomerTaskTypeUserSkipRequest): Observable<any> {
    return this.http.post(`${this.baseUrl}/SkipCustomerTaskType`, request);
  }

  deleteCustomerSkips(taskTypeId: number = undefined): Observable<any> {
    return this.http.post(`${this.baseUrl}/DeleteUserSkips`, taskTypeId);
  }
}
